import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import DeliverPersonalization from './components/DeliverPersonalization'
import MultichannelMessaging from './components/MultichannelMessaging'
import Scale from './components/Scale'

import ogImagePng from './assets/OgWhatsApp.png'

const WhatsAppView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="WhatsApp | Twilio Segment"
        pageDescription="With an audience of over 2 billion users, WhatsApp is the perfect channel for marketers to connect and engage with their global audiences. By leveraging WhatsApp, marketers can reach new markets, create meaningful relationships, and grow their brand presence natively in Twilio Engage."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.cloud[100]}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <Wrapper>
            <DeliverPersonalization />
            <MultichannelMessaging />
            <Scale />
          </Wrapper>
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default WhatsAppView

const Wrapper = styled.div`
  padding-bottom: 20px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 80px;
  }
`

const Main = styled.main``
